import { Grid, Container, Typography, Box } from '@mui/material';
import logo_main_page from '~/assets/logo.png';
import { styles } from './styles';

type HeaderBlockProps = {
  titleText: string;
};

export const HeaderBlock = ({ titleText }: HeaderBlockProps) => {
  return (
    <Grid container component="header" sx={styles.containerHeader}>
      <Container maxWidth="xl" disableGutters>
        <Grid container sx={styles.gridContainer}>
          <Grid>
            <Box component="img" src={logo_main_page} alt="logo" sx={styles.imgLogo} />
          </Grid>
          <Typography variant={'h6'} sx={styles.title}>
            {titleText}
          </Typography>
          <Grid></Grid>
        </Grid>
      </Container>
    </Grid>
  );
};
